import { lazy } from 'react';

import type { PublicationItemAttributes } from 'hb-builder/components/BuilderComponents/dynamic/Publication/types';
import DefaultTabs from 'hb-builder/components/Layout/Panel/Tabs/DefaultTabs';
import type { ComponentSettingsTab } from 'hb-builder/types/settings';

const tabsContent = {
  content: lazy(() => import('./Content')),
  style: lazy(() => import('./Style')),
};

const PublicationSettings = ({
  defaultAttributes,
  item,
  onChange,
  permissions,
  tabs,
}: ComponentSettingsTab<PublicationItemAttributes>) => (
  <DefaultTabs
    // Force re-mount when the item changes
    key={item.id}
    item={item}
    tabs={tabs}
    tabsContent={tabsContent}
  >
    {({ selectedTab }) => {
      const SettingMode = tabsContent[selectedTab];

      return (
        <SettingMode
          defaultAttributes={defaultAttributes}
          item={item}
          onChange={onChange}
          permissions={permissions}
        />
      );
    }}
  </DefaultTabs>
);

export default PublicationSettings;
